import {
  FormField,
  type FormFieldProps,
  Textarea,
  type TextareaProps,
} from "@aurem/ui";
import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { get } from "../../utils";

type IProps = Omit<TextareaProps, "label"> &
  Partial<FormFieldProps> & {
    name: string;
    formElementClass?: string;
  };

export const TextareaControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    description,
    size = "md",
    ...restTextareaProps
  } = props;
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const textareaId = useId();

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        return (
          <Textarea
            {...restTextareaProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            id={textareaId}
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={textareaId}
      size={size}
    >
      {inputElement}
    </FormField>
  );
};
